import {
  createRouter,
  createWebHistory,
  type RouteMeta,
  type RouteRecordRaw
} from 'vue-router'
import OverviewPage from '@/views/OverviewPage.vue'
import { isDa } from '@/utils/CommonUtils'
import ThankYouPageVue from '@/views/ThankYouPage.vue'
import { isLocal } from '@/utils/utils'
import routerKundenportal from '@/routerTenant/router.kundenportal'
import { initKeycloak } from '@/keycloak.setup'
import { isAuthenticated, renewTokenWithRedirect } from '@/utils/KeycloakUtils'
import ActivationExpiredPage from '@/views/ActivationExpiredPage.vue'
import ActivationPage from '@/views/ActivationPage.vue'
import ChangeAddress from '@/components/partner-proxy/self-services/ChangeAddress.vue'
import ChangeBankDataPage from '@/views/ChangeBankDataPage.vue'
import ChangeEmailPage from '@/views/ChangeEmailPage.vue'
import ChangeMotorCockpitPage from '@/viewsTenant/ChangeMotorCockpitPage.vue'
import ChangeName from '@/components/partner-proxy/self-services/ChangeName.vue'
import ChangeVehiclePage from '@/viewsTenant/ChangeVehiclePage.vue'
import EnterPukTestView from '@/views/EnterPukTestView.vue'
import IdLevelUpgradePage from '@/views/IdLevelUpgradePage.vue'
import MotorContractTerminationPage from '@/viewsTenant/MotorContractTerminationPage.vue'
import MotorPolicyDetailsTestView from '@/views/MotorPolicyDetailsTestView.vue'
import PartnerAddressTest from '@/testViews/partner-proxy/PartnerAddressTest.vue'
import PaymentDataTestView from '@/views/PaymentDataTestView.vue'
import PoliciesPage from '@/views/PoliciesPage.vue'
import PolicyDetailsPage from '@/views/PolicyDetailsPage.vue'
import PolicyTileTestView from '@/views/PolicyTileTestView.vue'
import PostboxPage from '@/views/PostboxPage.vue'
import PreBeitragsbescheinigungPage from '@/views/PreBeitragsbescheinigungPage.vue'
import QuoteDetailsPage from '@/views/QuoteDetailsPage.vue'
import RegistrationPage from '@/views/RegistrationPage.vue'
import RegistrationSuccessfulPage from '@/views/RegistrationSuccessfulPage.vue'
import RequestBeitragsbescheinigungPage from '@/views/RequestBeitragsbescheinigungPage.vue'
import ResetPasswordPage from '@/views/ResetPasswordPage.vue'
import SHURPolicyDetailsTestView from '@/views/SHURPolicyDetailsTestView.vue'
import ServiceCodeRequestPage from '@/views/ServiceCodeRequestPage.vue'
import UserExistsPage from '@/views/UserExistsPage.vue'
import UsernameChange from '@/components/account-management/usernamechange/UsernameChange.vue'
import UsernameRetrievalPage from '@/views/UsernameRetrievalPage.vue'
import VertragsServicesPage from '@/views/VertragsServicesPage.vue'
import RequestDigitalCardPage from '@/views/RequestDigitalCardPage.vue'
import RequestAccompaniedDrivingPage from '@/views/RequestAccompaniedDrivingPage.vue'
import { updateTrackingInformation } from '@/utilsTenant/tracking'
import LoginHelpPage from '@/viewsTenant/LoginHelpPage.vue'
import VehicleSaleNotificationPage from '@/viewsTenant/VehicleSaleNotificationPage.vue'
import { getBaseURL } from '@/utils/baseUrl'
import ClaimsPage from '@/views/ClaimsPage.vue'
import PersonalProfilPage from '@/views/PersonalProfilPage.vue'
import IVKAnfordernPage from '@/views/IVKAnfordernPage.vue'
import { startRouteProgress, stopRouteProgress } from '@/composables/useRouteProgress'
import NotFoundPage from '@/views/NotFoundPage.vue'

let firstStart = true

export interface RouteMetaInfo extends RouteMeta {
  isNavi: boolean
  naviLabel: string
  requiresAuth: boolean
}

export const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/ueberblick' },
  { path: '/anmelden', name: 'anmelden', redirect: '/ueberblick' },
  {
    path: '/ueberblick',
    name: 'ueberblick',
    meta: {
      isNavi: true,
      naviLabel: 'Überblick',
      requiresAuth: true
    } as RouteMetaInfo,
    component: OverviewPage
  },
  {
    path: '/postfach',
    name: 'postfach',
    meta: {
      isNavi: true,
      naviLabel: 'Postfach',
      requiresAuth: true
    } as RouteMetaInfo,
    component: PostboxPage
  },
  {
    path: '/vertraege',
    name: 'vertraege',
    meta: {
      isNavi: true,
      naviLabel: 'Verträge',
      requiresAuth: true
    } as RouteMetaInfo,
    component: PoliciesPage
  },
  {
      path: '/schaeden',
      name: 'schaeden',
      meta: {
        isNavi: true,
        naviLabel: 'Schäden',
        requiresAuth: true,
        showSubline: false
      } as RouteMetaInfo,
      component: ClaimsPage
    },
  {
    path: '/einstellungen',
    redirect: '/persoenliches-profil'
  },
  {
    path: '/persoenliche-daten',
    redirect: '/persoenliches-profil'
  },
  {
    path: '/persoenliches-profil',
    name: 'personalProfil',
    meta: {
      isNavi: true,
      naviLabel: 'Persönliches Profil',
      requiresAuth: true,
      showSubline: true
    } as RouteMetaInfo,
    component: PersonalProfilPage
  },
  {
    path: isDa() ? '/vertrags-services' : '/vertragsservices',
    name: 'vertragsServices',
    meta: {
      isNavi: true,
      naviLabel: isDa() ? 'Vertragsservice' : 'Vertragsservices',
      requiresAuth: true
    } as RouteMetaInfo,
    component: VertragsServicesPage
  },
  {
    path: '/aktivierung',
    name: 'aktivierung',
    component: ActivationPage
  },
  {
    path: '/persoenliches-profil/passwort',
    name: 'passwort',
    meta: {
      naviLabel: 'Persönliches Profil',
      requiresAuth: true
    },
    component: ResetPasswordPage
  },
  {
    path: '/persoenliches-profil/mail',
    name: 'email',
    meta: {
      naviLabel: 'Persönliches Profil',
      requiresAuth: true,
      showSubline: true
    },
    component: ChangeEmailPage
  },
    {
    path: '/persoenliches-profil/benutzername',
    name: 'changeUsername',
    meta: {
      naviLabel: 'Persönliches Profil',
      requiresAuth: true,
      showSubline: true
    },
    component: UsernameChange

  },
  {
    path: '/persoenliches-profil/freischaltcode-eingeben',
    name: 'servicecodeEingeben',
    meta: {
      naviLabel: 'Persönliches Profil',
      requiresAuth: true,
      showSubline: true
    },
    component: IdLevelUpgradePage
  },
  {
    path: '/persoenliches-profil/freischaltcode-anfordern',
    name: 'servicecodeAnfordern',
    meta: {
      naviLabel: 'Persönliches Profil',
      requiresAuth: true
    },
    component: ServiceCodeRequestPage
  },
  {
    path: '/benutzername-vergessen',
    name: 'benutzername-vergessen',
    component: UsernameRetrievalPage
  },
  {
    path: '/aktivierung-abgelaufen',
    name: 'aktivierung-abgelaufen',
    component: ActivationExpiredPage
  },
  {
    path: '/passwort-neu-vergeben',
    name: 'passwort-neu-vergeben',
    component: ResetPasswordPage
  },
  { path: '/registrierung', redirect: '/registrieren' },
  {
    path: '/registrieren',
    name: 'registrierung',
    component: RegistrationPage
  },
  {
    path: '/registrieren-bestaetigung',
    name: 'registrieren-bestaetigung',
    component: RegistrationSuccessfulPage
  },
  {
    path: '/registrieren-vorhanden',
    name: 'registrieren-vorhanden',
    component: UserExistsPage
  },
  {
    path: '/persoenliches-profil/name-aendern',
    name: 'changeName',
    meta: {
      naviLabel: 'Persönliches Profil',
      requiresAuth: true,
      showSubline: true
    },
    component: ChangeName
  },
  {
    path: '/persoenliches-profil/adresse-aendern',
    name: 'changeAddress',
    meta: {
      naviLabel: 'Persönliches Profil',
      requiresAuth: true,
      showSubline: true
    },
    component: ChangeAddress
  },
  {
    path: '/persoenliches-profil/bankdaten-aendern',
    name: 'changeBankData',
    meta: {
      naviLabel: 'Persönliches Profil',
      requiresAuth: true,
      showSubline: true
    },
    component: ChangeBankDataPage
  },
  {
    path: '/vertraege/policen/:line/:partnerAddressId/:policyId',
    name: 'policen',
    meta: {
      isNavi: false,
      requiresAuth: true,
      showSubline: true
    },
    component: PolicyDetailsPage
  },
  {
    path: '/abschluss/:quoteId',
    name: 'quotes',
    meta: {
      isNavi: false,
      requiresAuth: true,
      showSubline: true
    },
    component: QuoteDetailsPage
  },
  {
    path: '/danke',
    name: 'danke',
    meta: {
      requiresAuth: true,
      showSubline: false
    },
    component: ThankYouPageVue
  }
]

if (isDa()) {
  routes.splice(
    5,
    0,
    {
      path: '/vertrags-services/bescheinigung-fuer-begleitetes-fahren-anfordern',
      name: 'requestAccompaniedDriving',
      meta: {
        isNavi: false,
        naviLabel: 'Vertragsservice',
        requiresAuth: true
      },
      component: RequestAccompaniedDrivingPage
    },
    {
      path: '/vertrags-services/digitale-schadenkarte-anfordern',
      name: 'requestDigitalCard',
      meta: {
        isNavi: false,
        naviLabel: 'Vertragsservice',
        requiresAuth: true
      },
      component: RequestDigitalCardPage
    },
    {
      path: '/vertrags-services/fahrzeug-verkauf-mitteilen',
      name: 'vehicleSaleNotification',
      meta: {
        isNavi: false,
        naviLabel: 'Vertragsservice',
        requiresAuth: true
      },
      component: VehicleSaleNotificationPage
    },
    {
      path: '/vertrags-services/motor-cockpit-fahrleistung',
      name: 'motorCockpitFahrleistung',
      meta: {
        requiresAuth: true
      },
      component: ChangeMotorCockpitPage
    },
    {
      path: '/vertrags-services/motor-cockpit-versicherungsumfang',
      name: 'motorCockpitVersicherungsumfang',
      meta: {
        requiresAuth: true
      },
      component: ChangeMotorCockpitPage
    },
    {
      path: '/vertrags-services/motor-cockpit-fahrerkreis',
      name: 'motorCockpitFahrerkreis',
      meta: {
        requiresAuth: true
      },
      component: ChangeMotorCockpitPage
    },
    {
      path: '/vertrags-services/internationale-versicherungskarte-anfordern',
      name: 'ivkAnfordern',
      meta: {
        requiresAuth: true
      },
      component: IVKAnfordernPage
    },
    {
      path: '/vertraege/policen/motor/:partnerAddressId/:policyId/fahrzeug-wechseln',
      name: 'fahrzeugWechseln',
      meta: {
        requiresAuth: true
      },
      component: ChangeVehiclePage
    },
    {
      path: '/vertraege/policen/motor/:partnerAddressId/:policyId/vertrag-kuendigen',
      name: 'vertragKuendigen',
      meta: {
        isNavi: false,
        naviLabel: 'Vertragsservice',
        requiresAuth: true
      } as RouteMetaInfo,
      component: MotorContractTerminationPage
    },
    {
      path: '/anmeldung-hilfe',
      name: 'anmeldung-hilfe',
      component: LoginHelpPage
    }
  )
}

if (!isDa()) {
  routes.splice(
    3,
    0,
    {
      path: '/vertragsservices/beitragsbescheinigung-anfordern',
      name: 'requestBeitragsbescheinigung',
      meta: {
        isNavi: false,
        naviLabel: 'Vertragsservice',
        requiresAuth: true
      } as RouteMetaInfo,
      component: RequestBeitragsbescheinigungPage
    },
    {
      path: '/vertragsservices/pre-beitragsbescheinigung-anfordern',
      name: 'preBeitragsbescheinigung',
      meta: {
        isNavi: false,
        naviLabel: 'Vertragsservice',
        requiresAuth: true
      } as RouteMetaInfo,
      component: PreBeitragsbescheinigungPage
    },
    {
      path: '/vertragsservices/digitale-versicherungskarte-anfordern',
      name: 'requestDigitalCard',
      meta: {
        isNavi: false,
        naviLabel: 'Vertragsservice',
        requiresAuth: true
      } as RouteMetaInfo,
      component: RequestDigitalCardPage
    },
    {
      path: '/vertragsservices/internationale-versicherungskarte-anfordern',
      name: 'ivkAnfordern',
      meta: {
        requiresAuth: true
      },
      component: IVKAnfordernPage
    }
  )
}

const enableTestViews = false

if (isLocal() && enableTestViews) {
  routes.push(
    {
      path: '/test/partner-proxy/partnerAddress',
      name: 'partnerAddress',
      meta: {
        requiresAuth: true
      },
      component: PartnerAddressTest
    },
    {
      path: '/enterpuktest',
      name: 'enterpuktest',
      meta: {
        isNavi: true,
        naviLabel: 'EnterPukTestView',
        requiresAuth: true,
        showSubline: false
      } as RouteMetaInfo,
      component: EnterPukTestView
    },
    {
      path: '/paymentdatatest',
      name: 'paymentdatatest',
      meta: {
        isNavi: true,
        naviLabel: 'PolicyTileTestView',
        requiresAuth: true,
        showSubline: false
      } as RouteMetaInfo,
      component: PaymentDataTestView
    },
    {
      path: '/tiletest',
      name: 'tiletest',
      meta: {
        isNavi: true,
        naviLabel: 'PolicyTileTestView',
        requiresAuth: true,
        showSubline: false
      } as RouteMetaInfo,
      component: PolicyTileTestView
    },
    {
      path: '/shurdetailstest',
      name: 'shurdetailstest',
      meta: {
        isNavi: true,
        naviLabel: 'SHURPolicyDetailsTestView',
        requiresAuth: true,
        showSubline: false
      } as RouteMetaInfo,
      component: SHURPolicyDetailsTestView
    },
    {
      path: '/motordetailstest',
      name: 'motordetailstest',
      meta: {
        isNavi: true,
        naviLabel: 'MotorPolicyDetailsTestView',
        requiresAuth: true,
        showSubline: false
      } as RouteMetaInfo,
      component: MotorPolicyDetailsTestView
    }
  )
}

routes.concat(routerKundenportal)

routes.push({
  path: '/:pathMatch(.*)*',
  name: 'notFound',
  meta: {
    requiresAuth: false
  },
  component: NotFoundPage
})

export const router = createRouter({
  history: createWebHistory(getBaseURL()),
  routes
})

router.isReady().then(async () => {
  updateTrackingInformation(router.currentRoute.value)
})

router.beforeEach(async (to, from, next) => {
  startRouteProgress()
  updateTrackingInformation(to)
  if (to.meta?.requiresAuth && (!window.keycloak || !window.keycloak?.authenticated)) {
    await initKeycloak()
    if (firstStart) {
      firstStart = false
      next()
      return
    }
  } else if (to.meta?.requiresAuth && isAuthenticated()) {
    await renewTokenWithRedirect()
    if (firstStart) {
      firstStart = false
      next()
      return
    } else {
      next()
      return
    }
  } else {
    window.dispatchEvent(
      new CustomEvent('cp_load_public_pages', {
        bubbles: true,
        detail: {}
      })
    )
    next()
    return
  }
})

router.afterEach(() => {
  stopRouteProgress()
  window.scrollTo({ top: 0, behavior: 'smooth' })
})